import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { DELETE_MASTER_ACTION_TYPE, deleteMasterUrl, deletePromoCodeUrl, GET_MASTER_DETAILS_ACTION_TYPE, GET_MASTER_LIST_ACTION_TYPE, getMasterDetailsUrl, getMasterListUrl, getPromoCodeDetailsUrl, getPromoCodeListUrl, headers, INSERT_MASTER_ACTION_TYPE, INSERT_UPDATE_MASTER_ACTION_TYPE, insertPromoCodeUrl, insertUpdateMasterUrl, insertUpdatemasterUrl, insertUpdatePromoCodeUrl, UPDATE_MASTER_ACTION_TYPE, updatePromoCodeUrl, } from "../../utils/constants"

export const get_master_list_action = (Name, statusId, type) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            Name: Name ? Name : null,
            statusId: statusId ? statusId : 1,
            type: type ? type : null,
        }
        const res = await axiosGet(getMasterListUrl, mapdata, headers);

        dispatch({
            type: GET_MASTER_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_master_details_action = (ID, type) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            ID: ID, type: type
        }
        const res = await axiosGet(getMasterDetailsUrl, mapdata, headers);
        dispatch({
            type: GET_MASTER_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insert_update_master_action = (ID, Name, type) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            ID: ID, Name: Name,
            type: type
        }

        console.log("share_credential_action res", mapdata)
        const res = await axiosPost(insertUpdateMasterUrl, mapdata, headers);

        dispatch({
            type: INSERT_UPDATE_MASTER_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const delete_master_action = (ID, type) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            ID: ID, type: type
        }
        const res = await axiosGet(deleteMasterUrl, mapdata, headers);
        dispatch({
            type: DELETE_MASTER_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};